import React from 'react';
import {
  Typography,
  Wrap,
  Icon,
  ErrorDisplay,
  SkeletonLoader,
  Button,
  LocationDropdown,
} from '../../components/index';
import Styled from './PageLeaderboard.style';
import { Row, Col } from 'react-styled-flexboxgrid';
import store from 'store2';
import * as _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { prettifyIfNumber } from '../../helpers/helpers';
interface PageLeaderboardProps {
  leaderboard: any;
  listLocation: any;
  getLeaderboard: Function;
  setMeta: Function;
}

export const PageLeaderboard: React.FC<PageLeaderboardProps> = (props) => {
  const { listLocation, leaderboard, getLeaderboard, setMeta } = props;
  const initialPropertyId = Number(store.get('property')) || 0;
  const navigate = useNavigate();
  const { error, loading, done } = props.leaderboard.status;

  const data = _.get(leaderboard, 'data.data');
  const dataLocation = _.get(listLocation, 'data.data');
  const dataLength = _.get(dataLocation, 'length');
  const dataMessage = _.get(data, 'message');
  const findLocation = _.find(data, function (o) {
    return o.organisationPropertyId == initialPropertyId;
  });
  const [propertyId, setPropertyId] = React.useState<number>(initialPropertyId);
  React.useEffect(() => {
    getLeaderboard(initialPropertyId);
  }, [initialPropertyId]);

  if (error) {
    return (
      <Wrap>
        <ErrorDisplay />
      </Wrap>
    );
  }
  if (loading && !done) {
    return (
      <Wrap>
        <SkeletonLoader />
      </Wrap>
    );
  }

  if (dataMessage) {
    return (
      <Wrap>
        <Styled.NoLocationBanner>
          <div
            style={{
              marginRight: '64px',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              style={{ fontSize: '30px', width: '320px', marginBottom: '24px' }}
              size="1"
              text="Get started by adding your location"
            />
            <Button
              onClick={() => navigate('/add-location')}
              style={{ borderRadius: '32px', textTransform: 'none' }}
            >
              Add your location
            </Button>
          </div>
        </Styled.NoLocationBanner>
      </Wrap>
    );
  }
  const renderMapOptions =
    dataLocation &&
    dataLocation.map((el) => ({
      value: el.id,
      label: el.property_name,
    }));
  const renderLeaderboard = () => {
    return (
      data &&
      data.slice(0, 10).map((el, index) => {
        const postcodeName = `Postcode ${el.postcode}`;
        const propertyName = el.propertyName;
        const litresPerPerson = `${prettifyIfNumber(parseInt(el.litresPerPerson))} L/person/day`;
        return (
          <Col key={index} md={12} xs={12} sm={12}>
            <Styled.Box
              highlighted={index < 3}
              current={el.organisationPropertyId === initialPropertyId}
              className={
                el.organisationPropertyId === initialPropertyId
                  ? 'current-property'
                  : ''
              }
            >
              {index < 3 ? (
                <div
                  style={{
                    width: '160px',
                    borderRight: '1px solid #21AAE8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {index === 0 && (
                    <Icon
                      icon="goldMedal"
                      colorPrimary="#FFD700"
                      colorSecondary="black"
                      size={60}
                    />
                  )}
                  {index === 1 && (
                    <Icon
                      icon="silverMedal"
                      colorPrimary="#C0C0C0"
                      colorSecondary="black"
                      size={60}
                    />
                  )}
                  {index === 2 && (
                    <Icon
                      icon="bronzeMedal"
                      colorPrimary="#CD7F32"
                      colorSecondary="black"
                      size={60}
                    />
                  )}
                </div>
              ) : (
                <div
                  style={{
                    width: '160px',
                    borderRight: '1px solid #21AAE8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    text={`${index + 1}`}
                    size="p"
                    style={{ margin: 0 }}
                  />
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  marginLeft: '16px',
                  justifyContent: 'center',
                  borderRight: '1px solid #21AAE8',
                }}
              >
                <Typography
                  size="4"
                  text={propertyName}
                  style={{
                    fontSize: index < 3 ? '24px' : '20px',
                    marginBottom: '4px',
                  }}
                />
                <Typography
                  size="p"
                  text={postcodeName}
                  style={{ margin: 0, fontSize: index < 3 ? '16px' : '14px' }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0px 16px',
                  minWidth: '187px',
                }}
              >
                <Icon icon="droplet" size={20} style={{ marginRight: '8px' }} />
                <Typography
                  text={litresPerPerson}
                  size="p"
                  style={{ margin: 0, fontWeight: 600 }}
                />
              </div>
            </Styled.Box>
          </Col>
        );
      })
    );
  };

  return (
    <Wrap>
      <Row style={{ marginBottom: '32px' }}>
        <Col md={8} xs={12} sm={12}>
          {' '}
          <Typography size="1" text="Water-saving leaderboard" />
        </Col>

        {dataLength <= 1 ? null : (
          <Col md={4} xs={12} sm={12}>
            <Styled.DropdownWrap>
              <LocationDropdown
                value={String(propertyId)}
                onChange={(e) => {
                  const id = Number(e.target.value);

                  setPropertyId(id);
                  store('property', id);
                  setMeta(id);
                  getLeaderboard(id);
                }}
                options={renderMapOptions}
              />
            </Styled.DropdownWrap>
          </Col>
        )}
      </Row>
      <Row>{renderLeaderboard()}</Row>
      <Row>
        <Col md={12} xs={12} sm={12}>
          {findLocation === undefined && (
            <Styled.Box className="no-read" style={{ background: '#21AAE8' }}>
              <div style={{ paddingLeft: '16px' }}>
                <Typography
                  text={`Looks like you havent submitted any meter readings.`}
                  size="p"
                  style={{ margin: 0, fontWeight: 600 }}
                />
                <Typography
                  text="Submit your meter read now to see where you are."
                  size="p"
                  style={{ margin: 0 }}
                />
              </div>
              <Styled.NoReadButton
                onClick={() => navigate('/meter-read')}
                appearance="OUTLINED"
                style={{ borderRadius: '32px', textTransform: 'none' }}
              >
                Submit meter read
              </Styled.NoReadButton>
            </Styled.Box>
          )}
          {findLocation && data && data.length > 10 && (
            <Styled.Box style={{ background: '#21AAE8' }}>
              <div
                style={{
                  width: '160px',
                  borderRight: '1px solid white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  text={findLocation.position}
                  size="p"
                  style={{ margin: 0, fontWeight: 600 }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  marginLeft: '16px',
                  justifyContent: 'center',
                  borderRight: '1px solid white',
                }}
              >
                <Typography
                  size="3"
                  text={findLocation.propertyName}
                  style={{ fontSize: '24px' }}
                />
                <Typography
                  size="p"
                  text={`Postcode: ${findLocation.postcode}`}
                  style={{ margin: 0 }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0px 16px',
                  minWidth: '187px',
                }}
              >
                <Icon
                  icon="droplet"
                  size={20}
                  colorSecondary="#D7F1FE"
                  style={{ marginRight: '8px' }}
                />
                <Typography
                  text={`${prettifyIfNumber(parseInt(findLocation.litresPerPerson))} L/person/day`}
                  size="p"
                  style={{ margin: 0, fontWeight: 600 }}
                />
              </div>
            </Styled.Box>
          )}
        </Col>
      </Row>
    </Wrap>
  );
};

export default PageLeaderboard;
